import { render, staticRenderFns } from "./cvc-migration-rollback-after.vue?vue&type=template&id=90fb3caa"
import script from "./cvc-migration-rollback-after.vue?vue&type=script&lang=js"
export * from "./cvc-migration-rollback-after.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports